import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class InvVoucherKind extends EntityBase {
  public IsWarehouse: boolean;
  public Active: boolean;
  public AutoCreateVoucherKindCode?: number;
  public AutoCreateVoucherKindId?: number;
  public AutoCreateVoucherKindLatinTitle: string;
  public AutoCreateVoucherKindTitle: string;
  public AutoFocusedDocumentIssuance: boolean;
  public CanChangeRefereAmount: boolean;
  public CanChangeReferePrice: boolean;
  public CheckValidDate: boolean;
  public CheckWithBaseAmount: boolean;
  public Code: number;
  public Comment: string;
  public CreditFunctionKindCode?: number;
  public CreditFunctionKindId?: number;
  public CreditFunctionKindLatinTitle: string;
  public CreditFunctionKindTitle: string;
  public ItemAdjustmentKindId?: number;
  public HasAutoConfirm: boolean;
  public HasBaseBranch: boolean;
  public HasChangeInvoicecredit: boolean;
  public HasCheckVoucherDate: boolean;
  public HasCredit: boolean;
  public HasCurrentBranch: boolean;
  public HasReceiptDate: boolean;
  public HasSlaveNo: boolean;
  public HasTaxDuty: boolean;
  public HasTraceElement: boolean;
  public IncrementalKindCode?: number;
  public IncrementalKindLatinTitle: string;
  public IncrementalKindTitle: string;
  public Invoicecredit: number;
  public IsBasedVerifiedDocuments: boolean;
  public LatinComment: string;
  public LatinTitle: string;
  public OrderByNumber: number;
  public FormOperationKindId?: number;
  public FormOperationKindCode?: number;
  public FormOperationKindTitle: string;
  public HasWarehouseTransfer: boolean;
  public ReferenceVoucherKindIsRequired: boolean;
  public ReserveBalance: boolean;
  public SlaveNoCaption: string;
  public SystemKindId: number;
  public SystemKindCode?: number;
  public SystemKindTitle?: string;
  public Title: string;
  public ToDayDate: boolean;
  public BasedOnBOM: boolean;
  public DefaultSubLedgerCode?: number;
  public DefaultSubLedgerId?: number;
  public DefaultSubLedgerLatinTitle: string;
  public DefaultSubLedgerTitle: string;
  public DefaultWarehouseCode?: number;
  public DefaultWarehouseId?: number;
  public DefaultWarehouseLatinTitle: string;
  public DefaultWarehouseTitle: string;
  public DetailLedgerInLevelCode?: number;
  public DetailLedgerInLevelId?: number;
  public DetailLedgerInLevelLatinTitle: string;
  public DetailLedgerInLevelTitle: string;
  public GoodsDetailLedgerInLevelCode?: number;
  public GoodsDetailLedgerInLevelId?: number;
  public GoodsDetailLedgerInLevelLatinTitle: string;
  public GoodsDetailLedgerInLevelTitle: string;
  public HasDiscount: boolean;
  public HasExpiryDate: boolean;
  public HasGrdDetailAccessControl: boolean;
  public HasInventoryControl: boolean;
  public HasJournalVoucher: boolean;
  public HasJournalVoucherAuto: boolean;
  public HasOpositeParty: boolean;
  public HasPriceRefresh: boolean;
  public HasTransferee: boolean;
  public HasTransportInterface: boolean;
  public IncrementalKindId: number;
  public IsGroupByWithGoods: boolean;
  public NoChangeRefereWarehouseDetailLedger: boolean;
  public NoCheckBaseAmount: boolean;
  public NoUnitInBarCodeRead: boolean;
  public IsProductConversionForm: boolean;
  public OpositePartyCaption: string;
  public OpositePartyLatinCaption: string;
  public OpositePartyWarehouseCaption: string;
  public OpositePartyWarehouseLatinCaption: string;
  public Priceable: boolean;
  public ShowLastUnitPrice: boolean;
  public ShowStockAmount: boolean;
  public ShowWarehouse: boolean;
  public SingleOrIngredients: boolean;
  public TaxDutyIsEditable: boolean;
  public TransfereeCaption: string;
  public WarehouseCaption: string;
  public WarehouseLatinCaption: string;
  public WarehouseSubledgerCode?: number;
  public WarehouseSubledgerId?: number;
  public WarehouseSubledgerLatinTitle: string;
  public WarehouseSubledgerTitle: string;
  public DefaultSellKindCode?: number;
  public DefaultSellKindId?: number;
  public DefaultSellKindLatinTitle: string;
  public DefaultSellKindTitle: string;
  public DeliveryPlaceCaption: string;
  public HasCustomerRemain: boolean;
  public HasDeliveryPlace: boolean;
  public HasSellKind: boolean;
  public HassPriceUnit: boolean;
  public HasSubledger: boolean;
  public SellKindCaption: string;
  public WarehouseIsInHeader: boolean;
  public RahkaranVoucherKindId?: number;
  public RahkaranTransferId?: number;
  public RahkaranTransferCode?: number;
  public RahkaranTransferIdTitle: string;
  public FilterByProductHalfMade: boolean;
  public ReferenceVoucherKinds: ReferenceVoucherKind[];
  public VoucherKindDetailLedgerKinds: VoucherKindDetailLedgerKind[];
  public VoucherKindGoodss: VoucherKindGoods[];
}
export class ReferenceVoucherKind extends EntityBase {
  public InvVoucherKindCode?: number;
  public InvVoucherKindId?: number;
  public InvVoucherKindLatinTitle: string;
  public InvVoucherKindTitle: string;
  public IsDefault: boolean;
  public IsWarehouse: boolean;
  public ReferenceVoucherKindCode?: number;
  public ReferenceVoucherKindId: number;
  public ReferenceVoucherKindLatinTitle: string;
  public ReferenceVoucherKindTitle: string;
  public AutoCreateVoucherKindId?: number;
}
export class VoucherKindDetailLedgerKind extends EntityBase {
  public DetailLedgerKindCode?: number;
  public DetailLedgerKindId: number;
  public DetailLedgerKindTitle: string;
  public InvVoucherKindCode?: number;
  public InvVoucherKindId: number;
  public InvVoucherKindLatinTitle: string;
  public InvVoucherKindTitle: string;
  public IsWarehouse?: boolean;
}
export class VoucherKindGoods extends EntityBase {
  public GoodsGroupTreeCode: string;
  public GoodsGroupId: number;
  public GoodsGroupLatinTitle: string;
  public GoodsGroupTreePath: string;
  public InvVoucherKindCode?: number;
  public InvVoucherKindId: number;
  public InvVoucherKindLatinTitle: string;
  public InvVoucherKindTitle: string;
  public IsWarehouse: boolean;
}
